export const optionGroup = {
    "modal": {
      "confirmation": "Confirmación",
      "changeTextInputOption": "¿Desea activar el campo de texto?<br/>Tenga en cuenta que esta acción eliminará sus anidaciones actuales.",
      "deleteItem": "¿Está seguro que desea eliminar el item?<br/>Al hacerlo se eliminará las respectivas anidaciones",
      "changeSelection": "¿Está seguro que desea cambiar la selección?<br/>Al hacerlo perderá todos los cambios realizados y las respectivas anidaciones",
      "changeCatalogSelection": "¿Está seguro que desea cambiar la selección?<br/>Al hacerlo se eliminarán las respectivas anidaciones",
      "changeTextInput": "¿Desea activar el campo de texto?<br/>Tenga en cuenta que esta acción eliminará sus anidaciones actuales.",
      "delete": {
        "title": "¿Está seguro que desea eliminar este grupo de opciones?",
        "description": "",
        "error": "Ocurrió un error al eliminar el grupo de opciones",
        "success": "El grupo de opciones se eliminó exitosamente"
      },
      "cancel":{
        "title": "Confirmación",
        "description": "¿Está seguro que desea salir? Se perderán los cambios no guardados."
      },
    },
    "snackbar": {
      "selectOneTemplate": "Debes agregar al menos 2 opciones de respuesta.",
      "create": {
        "success": "El grupo de opciones se creó exitosamente",
        "error": "Ocurrió un error al crear el grupo de opciones"
      },
      "update": {
        "success": "El grupo de opciones se actualizó exitosamente",
        "error": "Ocurrió un error al actualizar el grupo de opciones"
      }
    },
    "filter": {
      "title": "Grupo de opciones",
      "filterTitle": "FILTRAR POR",
      "inputs": {
        "search": "Buscar grupo",
        "firstSelect": "Estatus del grupo",
        "rol": "Rol"
      }
    },
    "title": {
      "newOption": "Nuevo grupo de opciones",
      "editOption": "Editar grupo de opciones",
      "optionsAdded": "Opciones agregadas",
      "addOptions": "Agregar opciones",
      "noOptionsAddes": "Debes seleccionar al menos una categoría/servicio \n para crear el folio",
      "catalogLevels": "Niveles de catálogo",
    },
    "tags": {
      "title":{
        "optionName": "Nombre del grupo de opciones",
        "templateType": "Tipo de plantilla",
        "description": "Descripción",
        "subValueType": "Tipo de subvalor",
        "subValue": "Ingresar subvalor",
        "subCatalog": "Seleccione subcatálogo",
        "back": "Regresar"
      },
      "errors":{
        "optionName": "El campo nombre del grupo de opciones es requerido",
        "subValue": "El campo subvalor es requerido",
        "minLenght": "El campo debe contener un minimo de {{min}} caracteres"
      }
    },
    "buttons":{
      "addGroup": "Agregar grupo",
      "editGroup": "Editar grupo",
      "cancel": "Cancelar",
    },
    "informationCard": {
      "submit": {
        "create": "Agregar grupo",
        "edit": "Actualizar grupo"
      },
      "create": {
        "title": "Nuevo grupo de opciones"
      },
      "edit": {
        "title": "Editar grupo de opciones"
      },
      "buttons": {
        "add": "Agregar grupo",
        "cancel": "Cancelar",
        "edit": "Editar grupo"
      }
    }
  }